import { machine as patientMachine, OnboardPatientStateValue } from './state/machine-patient'
import {
  machine as practitionerMachine,
  OnboardPractitionerStateValue,
} from './state/machine-practitioner'

/**
 * Identify whether state from Auth0 claim is valid in state machine. Exclude final state
 * and `invalid` state (used as fallback)
 */

export const isValidPatientState = (
  state: string,
): state is Exclude<OnboardPatientStateValue, 'complete' | 'invalid'> => {
  return (
    !!state &&
    state !== 'complete' &&
    state !== 'invalid' &&
    Object.keys(patientMachine.states).includes(state)
  )
}

export const isValidPractitionerState = (
  state: string,
): state is Exclude<OnboardPractitionerStateValue, 'complete' | 'invalid'> => {
  return (
    !!state &&
    state !== 'complete' &&
    state !== 'invalid' &&
    Object.keys(practitionerMachine.states).includes(state)
  )
}

/*
  Functions and types to handle Practitioner Form State
  Ref: https://app.shortcut.com/designsforhealth/story/54970/discuss-implement-we-need-to-add-a-toast-message-banner-to-inform-existing-practitioners-they-need-to-upload-their-forms
*/

export type PractitionerFormActionTypes =
  | { type: 'prac_form_initialized' }
  | { type: 'toast_dismissed' }
  | { type: 'toast_selected' }
  | { type: 'commissions_pref_selected' }
  | { type: 'remind_me_later_selected' }
  | { type: 'onboarding_complete' }

type PractitionerFormAction = PractitionerFormActionTypes['type']

export interface PractitionerFormsState {
  lastEvent: PractitionerFormAction
  notifyAfter: string
}

export const isPractitionerFormsState = (formState: unknown): formState is PractitionerFormsState =>
  formState != null &&
  typeof formState === 'object' &&
  typeof (formState as Record<string, unknown>).lastEvent === 'string' &&
  typeof (formState as Record<string, unknown>).notifyAfter === 'string'
